import Text from '@eversports/react-components/primitives/Text'
import React from 'react'

interface Props {
  venue: string
}

const Venue: React.FC<React.PropsWithChildren<Props>> = ({ venue }) => (
  <Text is="span" textTransform="capitalize">
    {venue}
  </Text>
)

export default Venue
